export default {
  price: (value, type) => {
    if (!/^(0|[1-9]\d*)$/.test(value)) return '請輸入有效的價格'
    if (type && window.vm && type in window.vm.$product_price_limit) {
      const limit = window.vm.$product_price_limit[type]
      if (value < limit.min || value > limit.max) {
        return `價格須介於 ${limit.min} 至 ${limit.max} 之間`
      }
    }
    return true
  },
  email: value => /^\S+@\S+\.\S+$/.test(value) || '請輸入有效的電子郵件',
  password: value => /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,15}$/.test(value) || '密碼需6-15字元，包含英文和數字',
  integer: value => /^\d+$/.test(value) || '請輸入整數',
  measurements: value => /^\d+\/\d+\/\d+$/.test(value) || '格式需為 數字/數字/數字',
  cup: value => /^[a-zA-Z]$/.test(value) || '請輸入單一英文字母',
  float: value => /^\d+(\.\d+)?$/.test(value) || '請輸入數字',
  notEmpty: value => !!value || '此欄位為必填'
}